import NotificationsIcon from "@mui/icons-material/Notifications";
import { Button, MenuList, Stack } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ProfileIcon from "../../src/assets/images/profileIcon.svg";
import { ListKeys, getApplicationList } from "../api/list";
import { MuiIconButton, MuiSearchSelect } from "../components";
import { getUserByIdentityIdAPI, logout } from "../redux/authSlice";
import { setReducerState } from "../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { getLocalStorageItem, setLocalStorageItem } from "../utils/storageHelper";
import { Person } from "@mui/icons-material";


export default function Header() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { loginData, getUserByIdentityId } = useAppSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (!getUserByIdentityId) dispatch(getUserByIdentityIdAPI(loginData?.data?.IdentityId));
  }, [loginData]);

  const handleApplicationChange = (e?: any, value?: any) => {
    setLocalStorageItem("ApplicationId", value?.id);
    navigate(0);
  }

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    navigate("/");
    dispatch(logout());
    dispatch(setReducerState({ key: "activeRoutes", value: null }));
  };

  return (
    <>
      <Stack direction={"row"} sx={{ float: "right" }} px={1} justifyContent={"end"} alignItems='center' >
        <MuiSearchSelect
          name="ApplicationId"
          label={("Application")}
          disableClearable
          value={getLocalStorageItem('ApplicationId')}
          displayExpr="DisplayName"
          onChange={handleApplicationChange}
          placeholder='Select Application'
          getListData={getApplicationList}
          apiKey={ListKeys.applications}
          sx={{ mx: 1, width: '200px' }}
        />
        <Button
          variant='outlined'
          size='small'
          onClick={handleClick}
          color='secondary'
          sx={{ p: 0.5, minWidth: 'auto', minHeight: 'auto' }}
        >
          <Person color='secondary' fontSize='small' />
        </Button>
      </Stack>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
      >
        <MenuItem disabled >{getUserByIdentityId?.data?.LoginName || ""}</MenuItem>

        <MenuList>
          <MenuItem onClick={handleClose}>Profile</MenuItem>
          <MenuItem onClick={() => navigate("/change-password")}>
            Change Password
          </MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </MenuList>

      </Menu>
    </>
  );
}
